export default "__VITE_ASSET__Dfii1Qio__"